export default "__VITE_ASSET__b4cad383__"